import { head } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useMultiSelectState } from '../../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import { useMinicrudsState } from '../_load/MinicrudsLoader'
import MultiSelectMenu from '../../../../packages/kiti/components/multiSelect/MultiSelectMenu'
import { useMinicrudsActionsList } from '../../../../utils/actions/minicruds/list'

const MultiRowsActions = () => {
  const { minicruds } = useMinicrudsState()
  const { selecteds, getSelectedData } = useMultiSelectState()
  const selectedMinicruds = getSelectedData(minicruds)
  const menuOptions = useMinicrudsActionsList(head(selectedMinicruds), selecteds)

  return <MultiSelectMenu options={menuOptions} />
}

export default MultiRowsActions
